function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40.35,19.88c12.44,0,22.56,10.12,22.56,22.56s-10.12,22.56-22.56,22.56-22.56-10.12-22.56-22.56,10.12-22.56,22.56-22.56M40.35,14.88c-15.22,0-27.56,12.34-27.56,27.56s12.34,27.56,27.56,27.56,27.56-12.34,27.56-27.56-12.34-27.56-27.56-27.56h0Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M36,35.7l11.67,6.74-11.67,6.74v-13.47M33.85,29.13c-1.49,0-2.85,1.19-2.85,2.85v20.92c0,1.66,1.37,2.85,2.85,2.85.47,0,.96-.12,1.42-.39l18.12-10.46c1.9-1.1,1.9-3.84,0-4.94l-18.12-10.46c-.46-.27-.95-.39-1.42-.39h0Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/LastPlayed-inactive.cf49d0bf.svg";
export { SvgComponent as ReactComponent };